<template>
    <div class="comment">
        <div class="origin" v-if="tocontent">
            {{ tocontent }}
        </div>
        {{ content }}
    </div>
</template>

<script>
export default {
    props: {
        content: {},
        tocontent: {}
    },
}
</script>

<style>

</style>